module.exports = __webpack_public_path__ + "img/方向.4bae0106.svg";